import api from "@/axios";
import type { AxiosResponse } from "axios";
import type {Yarn, Delivery, Usage, WastageRequest} from "@/types/yarn-types";

export const getYarnsList = async (): Promise<Yarn[]> => {
    const response = await api.get("/merges");
    return response.data;
}

export const getYarnById = async (id: string): Promise<Yarn> => {
    const response = await api.get(`/merges/${id}`);
    return response.data;
}

export const addYarn = async (data: Yarn): Promise<AxiosResponse> => {
    const response = await api.post("/merges", data);
    return response.data;
}

export const editYarn = async (data: Yarn, id: string): Promise<void> => {
    const response = await api.patch(`/merges/${id}`, data);
    return response.data;
}

export const getYarnDeliveriesForYarn = async (yarnId: string): Promise<any> => {
    const response = await api.get(`/merges/${yarnId}/deliveries`);
    return response.data;
}

export const addMergeDeliveryToMerge = async (data: Delivery, yarnId: string): Promise<AxiosResponse> => {
    const response = await api.post(`/merges/${yarnId}/delivery`, data);
    return response.data;
}

export const addMergeUsageToMerge = async (data: Usage, yarnId: string): Promise<AxiosResponse> => {
    const response = await api.post(`/merges/${yarnId}/usage`, data);
    return response.data;
}

export const addMergeWastageToMerge = async (data: WastageRequest, yarnId: string): Promise<AxiosResponse> => {
    const response = await api.post(`/merges/${yarnId}/wastage`, data);
    return response.data;
}

export const updateMergeWastage = async (
    mergeId: string,
    wastageId: string,
    wastageData: {
        kiloOfYarnWasted: number
        dateRecorded: string
    }
) => {
    const response = await api.put(`/merges/${mergeId}/wastage/${wastageId}`, wastageData)
    return response.data
}

export const updateMergeDelivery = async (
    mergeId: string,
    deliveryId: string,
    deliveryData: Delivery
) => {
    const response = await api.put(`/merges/${mergeId}/deliveries/${deliveryId}`, deliveryData)
    return response.data
}

export const deleteMergeDelivery = async (
    mergeId: string,
    deliveryId: string
) => {
    const response = await api.delete(`/merges/${mergeId}/deliveries/${deliveryId}`)
    return response.data
}

export const deleteMergeWastage = async (
    mergeId: string,
    wastageId: string
) => {
    const response = await api.delete(`/merges/${mergeId}/wastage/${wastageId}`)
    return response.data
}

export const archiveMerge = async (mergeId: string) => {
    const response = await api.patch(`/merges/${mergeId}/archive`)
    return response.data
}

export const unarchiveMerge = async (mergeId: string) => {
    const response = await api.patch(`/merges/${mergeId}/unarchive`)
    return response.data
}

export const getArchivedMerges = async () => {
    const response = await api.get("/merges/archived")
    return response.data
}